import { feature as casSessionManagerFeature } from '@central-products/cas-session-manager';

export const casSessionManagerPlugin = {
  beforeBootstrap({ addBootstrapperFeature }) {
    addBootstrapperFeature(casSessionManagerFeature);
  },
};
